import * as React from "react";
import { useTranslation } from "react-i18next";
import Routes from "security-app/routing/Routes";
import { useInvestigationsCount } from "security-app/hooks/useInvestigationsAPI";
import NumberCard from "./NumberCard";
const ACTIVE_INVESTIGATIONS = { archived: ["false"] };
const CLOSED_ACTIVE_INVESTIGATIONS = { ...ACTIVE_INVESTIGATIONS, status: ["Closed"] };
function InvestigationsCounter() {
  const { t } = useTranslation("enterprise_security_app");
  const { count: total, loadingCount: loadingTotal } = useInvestigationsCount(ACTIVE_INVESTIGATIONS);
  const { count: closed, loadingCount: loadingClosed } = useInvestigationsCount(CLOSED_ACTIVE_INVESTIGATIONS);
  return /* @__PURE__ */ React.createElement(
    NumberCard,
    {
      value: total.toString(),
      label: t("investigations_counter.label"),
      subLabel: t("investigations_counter.sub_label", { closed }),
      replayLink: Routes.INVESTIGATIONS.LIST,
      loading: loadingTotal || loadingClosed
    }
  );
}
export default InvestigationsCounter;
